var React = require('react');

function LinkOut (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"20.5","stroke":"black","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M12.4884 29.4586L25.5833 16.3638L16.2974 16.3888L16.2821 13.5757L30.5082 13.5373L30.4243 27.7178L27.6111 27.7025L27.6591 18.3937L14.5413 31.5115L12.4884 29.4586Z","fill":"black","key":1})]);
}

LinkOut.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = LinkOut;

LinkOut.default = LinkOut;
